module.exports = __webpack_public_path__ + "img/02.89d8fe11.jpg";